import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type NumberLocaleConfig = {
	decimalSeparator: string;
	thousandSeparator: string;
	locale: string;
};

const LOCALE_CONFIGS: Record<string, NumberLocaleConfig> = {
	de: {
		decimalSeparator: ",",
		thousandSeparator: ".",
		locale: "de",
	},
	en: {
		decimalSeparator: ".",
		thousandSeparator: ",",
		locale: "en",
	},
};

const DEFAULT_LOCALE = "de";

export function useNumberLocale(): NumberLocaleConfig {
	const { i18n } = useTranslation();

	return useMemo(() => {
		const language = i18n.language ?? DEFAULT_LOCALE;
		const config = LOCALE_CONFIGS[language];
		return config ?? LOCALE_CONFIGS[DEFAULT_LOCALE]!;
	}, [i18n.language]);
}
